import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';
import type { FlowConfig } from '@swf/core/types/Wizard';

import useRmfBRFlow from './useRmfBRFlow';
import useRmfCAONFlow from './useRmfCAONFlow';
import useRmfDEFlow from './useRmfDEFlow';
import useRmfDefaultFlow from './useRmfDefaultFlow';
import useRmfESFlow from './useRmfESFlow';
import useRmfFRFlow from './useRmfFRFlow';
import useRmfITFlow from './useRmfITFlow';
import useRmfPTFlow from './useRmfPTFlow';
import useRmfROFlow from './useRmfROFlow';
import useRmfUKFlow from './useRmfUKFlow';
import useRmfUSMIFlow from './useRmfUSMIFlow';

const useRmfFlow = (): FlowConfig => {
  const CAONFlow = useRmfCAONFlow();
  const DEFlow = useRmfDEFlow();
  const UKFlow = useRmfUKFlow();
  const FRFlow = useRmfFRFlow();
  const ITFlow = useRmfITFlow();
  const PTFlow = useRmfPTFlow();
  const ROFlow = useRmfROFlow();
  const BRFlow = useRmfBRFlow();
  const ESFlow = useRmfESFlow();
  const USMIFlow = useRmfUSMIFlow();
  const defaultFlow = useRmfDefaultFlow();
  const siteId = useSelector(select.cms.getSiteId);
  const country = useSelector(select.country.getCountry);
  const isStandaloneRMF = useSelector(select.location.getPathname).includes('/real-money-form');
  const isRMOK = useSelector(select.account.isRealMoneyOK);
  const exitWizard = useWizardExit();

  const {
    data: { rmfPassed }
  } = useWizardContext();
  const rmfComplete = isStandaloneRMF && isRMOK && !rmfPassed;

  if (rmfComplete) {
    exitWizard();
  }

  const flow = {
    [Sites.CA_ON]: CAONFlow,
    [Sites.DE]: DEFlow,
    [Sites.FRA]: FRFlow,
    [Sites.ITA]: ITFlow,
    [Sites.POR]: PTFlow,
    [Sites.ROM]: ROFlow,
    [Sites.UK]: UKFlow,
    [Sites.SPA]: ESFlow,
    [Country.Brazil]: BRFlow,
    [Sites.USMI]: USMIFlow,
    [Sites.US_NJ]: USMIFlow,
    [Sites.US_PA]: USMIFlow,
    default: defaultFlow
  };
  // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
  return flow[siteId] || flow[country] || flow.default;
};

export default useRmfFlow;
